<div class="wm-studio-inspect-errors">
    <div class="inspect-container row">
        <wms-spinner *ngIf="codeInspectService.inspectErrorsLoadingFlag" name="services-inspect-errors"
            [size]="'md'"></wms-spinner>
        <div class="col-md-8 wm-tree-container wm-inspect-errors ">
            <span class="no-errors-message" *ngIf="isEmptyNode(nodeObj)">{{locale.LABEL_NO_INSPECT_ERRORS}}</span>
            <wms-tree name="wm-inspectionerrors-tree" [data]="nodeObj" *ngIf="!isEmptyNode(nodeObj)"
                (nodeClick)="handleErrorNodeClick($event)" [getChildren]="getChildrenErrorNodes"
                [expandByDefault]="true" [hasSearch]="false" class="list-type-tree"
                [selectedNode]="selectedNode"></wms-tree>
        </div>
        <div class="col-md-4 wm-inspect-errors-desc">
            <div *ngIf="isEmptyNode(activeObj) || isEmptyNode(nodeObj)" [ngClass]="{'error-desc': !codeInspectService.isPollingDone(), 'error-desc-responsive':  codeInspectService.pollStatus.showMessage }">
                <li *ngFor="let error of totalErrorsObj | keyvalue" class="row">
                    <span class="col-md-3 error-title">{{locale["LABEL_MESSAGE_" + $any(error.key).toUpperCase()
                        ]}}</span>
                    <span class="col-md-8">{{error.value}}</span>
                </li>
            </div>
            <div *ngIf="!isEmptyNode(activeObj) && !isEmptyNode(nodeObj)" [ngClass]="{'error-desc': !codeInspectService.isPollingDone(), 'error-desc-responsive': codeInspectService.pollStatus.showMessage }">
                <li><span class="col-md-2 error-title">{{locale.LABEL_DESCRIPTION}}:</span><span
                        class="col-md-8">{{activeObj.message}}</span></li>
                <li><span class="col-md-2 error-title">{{locale.LABEL_LOCATION}}:</span><span class="col-md-8"
                        (click)="navigateTo(activeObj)"><span class="file-errors">{{activeObj.fileName}}</span>
                        [{{activeObj.line}}, {{activeObj.column}}]</span></li>
                <li><span class="col-md-2 error-title">{{locale.LABEL_SUGGESTION}}:</span><span class="col-md-8"><a
                            target="_blank"
                            href="{{activeObj.suggestion}}">{{locale.LABEL_CLICK_HERE}}</a>{{locale.LABEL_MORE_DETAILS}}</span>
                </li>
            </div>
            <div class="wm-inspect-refresh-info" *ngIf="!codeInspectService.isPollingDone() && !codeInspectService.inspectErrorsLoadingFlag" [ngClass]="{'refresh-status-bar': codeInspectService.pollStatus.showMessage}">
              <span class="refresh-pending-title app-message"> <i class="loading icon fa fa-spinner fa-spin"></i> {{locale.MESSAGE_INSPECT_REFRESH_PENDING_STATUS}} </span>
              <span *ngIf="codeInspectService.pollStatus.showMessage"> {{locale.MESSAGE_INFO_JOB_TOO_LONG}} </span>
            </div>
        </div>
    </div>
</div>
